<template>
  <div v-loading="loading">
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header" >
        <div class="card-title">
          <span class="card-icon">
            <i class="flaticon2-delivery-package text-primary"></i>
          </span>
          <router-link :to="{ name: 'subcontractor-detail', params: {id: answer_id} }" v-slot="{ href, navigate, isActive, isExactActive }">
            <a href="href" @click="navigate"><u>{{detailAnswer.display_name}}</u></a>
          </router-link>
        </div>
        <div class="card-title">
          <div class="flex justify-content-end">
            <h3 class="card-label d-flex justify-content-end"><b class="title-header">予算報告</b></h3>
            <a v-if="url_link" style="font-size: 1rem" :href="url_link" target="_blank">{{url_link}}</a>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div>
          <div v-if="business_from && business_to">
            <p class="mb-0">事業期間：</p>
            <p>{{`${business_from} ~ ${business_to}`}}</p>
          </div>
          <p>表示期間</p>
        </div>
        <div class="mb-4">
          <div class="mb-4">
            <el-form ref="ruleForm" :model="form" class="form-base" v-on:submit.prevent="isSubmit=true">
              <div class="row ml-0" style=" align-items: center;">
                <div class="col- mr-2">
                  <el-form-item prop="date_from" style="margin-bottom:0">
                    <el-date-picker v-model="form.day_from.year" :picker-options="pickerOptions" type="year" value-format="yyyy" prefix-icon="el-icon-arrow-down"
                      @change="sortDate()" :editable="false"></el-date-picker>
                    <span> 年 </span>
                    <el-date-picker v-model="form.day_from.month" :picker-options="pickerOptions" type="month" format="MM" prefix-icon="el-icon-arrow-down"
                      @change="sortDate()" :default-value="form.day_from.year ? fromYear : new Date()" :editable="false">
                    </el-date-picker>
                    <span> 月 </span>
                  </el-form-item>
                </div>
                <div class="center-line mr-4">
                  <p style="font-size: 20px;margin-bottom: 0;"> ～ </p>
                </div>
                <div class="col- mr-6">
                  <el-form-item prop="date_to" style="margin-bottom:0">
                    <el-date-picker v-model="form.day_to.year" :picker-options="pickerOptions" type="year" value-format="yyyy" prefix-icon="el-icon-arrow-down"
                      @change="sortDate()" :editable="false"></el-date-picker>
                    <span> 年 </span>
                    <el-date-picker v-model="form.day_to.month" :picker-options="pickerOptions" type="month" format="MM" prefix-icon="el-icon-arrow-down"
                      @change="sortDate()" :default-value="form.day_to.year ? toYear : new Date()" :editable="false">
                    </el-date-picker>
                    <span> 月 </span>
                  </el-form-item>
                </div>

                <div class="col-">
                  <el-form-item prop="tax_flag" class="mb-0">
                    <el-select v-model="form.tax_flag" placeholder="">
                      <el-option
                        v-for="item in tax_options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <input type="hidden" name="_csrf" v-model="form._csrf" />
            </el-form>
          </div>
          <div class="row mb-4 align-items-end justify-content-between ml-4">
            <div class="row align-items-end">
              <div class="col-auto">
                <div class="mr-40">予算額: {{form2_price ? formatter(form2_price) : '--'}}</div>
              </div>
              <div class="col-auto">
                <div class="mr-40">実績額: {{form3_price ? formatter(form3_price) : '--'}}</div>
              </div>
              <div class="col-auto">予算消化率: {{avg_price ? avg_price : '--'}}</div>
            </div>
            <div class="text-right">
              <button class="btn btn-secondary mr-2" @click="toPerformanceReport">実績</button>
            </div>
          </div>
        </div>

        <el-table
          :data="tableCostData"
          border
          stripe
          max-height="700"
          header-cell-class-name="text-center header-padding"
          :header-cell-style="{ background: '#181c32', color: 'white' }"
        >
          <el-table-column fixed prop="title" label="項目" align="left" :width="Object.keys(tableData).length !== 0 ? '326' : ''"></el-table-column>
           <el-table-column v-for="header in listHeaders" :label="header" min-width="300" :prop="header" :formatter="formatCost" align="right" :key="header">
              <template slot-scope="scope" slot="header">
                {{header}}
                <div v-if="`${header}_status` in status">{{status[`${header}_status`] == 0 ? '申請中' : status[`${header}_status`] == 1 ? '承認済' : '否認'}}</div>

                <el-divider v-if="hasActual.sendBack.includes(header) || hasActual.denial.includes(header) || hasActual.approval.includes(header)"></el-divider>
                <button v-if="hasActual.approval.includes(header)" class="btn btn-secondary mr-2" @click="setApprove(header, 1)">承認</button>
                <button v-if="hasActual.denial.includes(header)" class="btn btn-secondary mr-2" @click="setApprove(header, 2)">否認</button>
                <button v-if="hasActual.sendBack.includes(header)" class="btn btn-secondary mr-2" @click="setApprove(header, 3)">差し戻し</button>
                  <div class="mt-5" v-if="tableData[header] && Object.keys(tableData[header].reject_reason).length !== 0">
                      <div>差し戻しコメント</div>
                      <div class="mt-3 comment-content">
                          <div class="mt-3" v-for="(reject_reason, index_reject_reason) in tableData[header].reject_reason" :key="index_reject_reason">
                              <div class="text-left">{{ reject_reason.created_at_xx }}</div>
                              <div class="text-left pl-5"> {{ reject_reason.comment }}</div>
                          </div>
                      </div>
                  </div>
              </template>
            </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      :lock-scroll="false"
      :visible.sync="dialog.dialog"
      width="50%"
      class="content_popup"
      :show-close="false"
      center>
        <div class="textwidget text-center">
            {{ dialog.headerText }}理由を入力してください
        </div>

        <el-input class="mt-10" type="textarea" :rows="3" placeholder="入力してください" v-model="dialog.reason"></el-input>

        <span slot="footer" class="dialog-footer">
          <el-button :disabled="dialog.reason.length == 0" class="btn_submit_dialog" @click="setStatus(dialog.date, dialog.status)">処理確定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex';
import { SET_TITLE_BUSINESS } from "@/core/services/store/business.module";
import { GET_DETAIL_ANSWER, CHECK_FORM_URL_USER } from "@/core/services/store/formAnswer.module";
import { ENV } from "@/core/config/env";
import { SUCCESS_MESSAGE } from "@/core/config/constant";
import { getCsrfRandom } from "@/core/services/store/auth.module";

export default {
  data() {
    return {
      loading: false,
      listHeaders: [],
      answer_id: null,
      url_link: '',
      form2_price: null,
      form3_price: null,
      avg_price: null,
      hasActual: {
        approval: [],
        denial: [],
        sendBack: []
      },
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      form: {
        day_from: {
          year: null,
          month: null
        },
        day_to: {
          year: null,
          month: null
        },
        tax_flag: 0,
        _csrf:''
      },
      business_from: '',
      business_to: '',
      tableData: {},
      status: {},
      dialog: {
        dialog: false,
        status: null,
        headerText: '',
        reason: '',
        date: ''
      },
      tax_options: [
        {
          value: 1,
          label: '税込み表示'
        },
        {
          value: 0,
          label: '税抜き表示'
        }
      ]
    };
  },
  watch: {
    'form.day_from.year': {
      handler: function () {
        if (!this.isSubmit && this.form.day_from.year && this.form.day_from.month) {
          this.form.day_from.month = new Date(
            this.form.day_from.year ? moment(this.form.day_from.year).format('yyyy') : new Date().getFullYear(),
            this.form.day_from.month ? moment(this.form.day_from.month).format('MM') - 1 : new Date().getMonth()
          )
        }
      },
      deep: true
    },
    'form.day_from.month': {
      handler: function () {
        if (!this.isSubmit) {
          this.form.day_from.year = this.form.day_from.month ? moment(this.form.day_from.month).format('yyyy') : this.form.day_from.year
        }
      },
      deep: true
    },
    'form.day_to.year': {
      handler: function () {
        if (!this.isSubmit && this.form.day_to.year && this.form.day_to.month) {
          this.form.day_to.month = new Date(
            this.form.day_to.year ? moment(this.form.day_to.year).format('yyyy') : new Date().getFullYear(),
            this.form.day_to.month ? moment(this.form.day_to.month).format('MM') - 1 : new Date().getMonth()
          )
        }
      },
      deep: true
    },
    'form.day_to.month': {
      handler: function () {
        if (!this.isSubmit) {
          this.form.day_to.year = this.form.day_to.month ? moment(this.form.day_to.month).format('yyyy') : this.form.day_to.year
        }
      },
      deep: true
    },
    form: {
      handler: async function () {
        await this.getData()
      },
      deep: true
    },
    "dialog.dialog"() {
      if (this.dialog.dialog == false) {
        this.dialog.reason = ''
      }
    }
  },
  async created() {
    this.loading = true;
    let query = {};

    this.answer_id = this.$route.params.answer_id
    await this.getDetailAnswer({ id: this.answer_id })
    await this.checkFormUrlUser()

    if (this.listCheckFormUsers.form2) {
      this.url_link = ENV.APP_URL_DOMAIN + `${this.detailAnswer.tenant_code}/${this.listCheckFormUsers.form1.form_url}/${this.detailAnswer.answer_id}/${this.listCheckFormUsers.form2.form_url}`
    }

    if (this.BusinessTitle == null) {
      await this.setTitleBusiness()
    }

    if (this.getBusiness) {
      this.form.day_from.month = new Date(this.getBusiness.jigyo_kikan_from)
      this.form.day_to.month = new Date(this.getBusiness.jigyo_kikan_to)

      this.business_from = moment(this.getBusiness.jigyo_kikan_from).format('YYYY/MM/DD')
      this.business_to = moment(this.getBusiness.jigyo_kikan_to).format('YYYY/MM/DD')
    }

    if (this.$route.query.dateStart) {
      query.dateStart = this.$route.query.dateStart
      const get_year = query.dateStart.indexOf('-');
      this.form.day_from.year = query.dateStart.slice(0, get_year)
      this.form.day_from.month = new Date(query.dateStart)
    }
    if (this.$route.query.dateEnd) {
      query.dateEnd = this.$route.query.dateEnd
      const get_year = query.dateEnd.indexOf('-');
      this.form.day_to.year = query.dateEnd.slice(0, get_year)
      this.form.day_to.month = new Date(query.dateEnd)
    }
    if (this.$route.query.tax_flag) {
      this.form.tax_flag = this.$route.query.tax_flag
    }
    this.form._csrf = getCsrfRandom()
    this.loading = false;
  },
  computed: {
    ...mapGetters(['form2', 'getBusiness', 'listItemNameForm2', 'answerChildStatus', 'answerChildErrors', 'form2Price', 'form3Price', 'averagePrice','BusinessTitle', 'detailAnswer', 'listCheckFormUsers', 'currentUser']),
    fromYear() {
      return this.form.day_from.year ? moment(this.form.day_from.year).format('yyyy') : new Date().getFullYear()
    },
    fromMonth() {
      return this.form.day_from.month ? moment(this.form.day_from.month).format('MM') - 1 : new Date().getMonth()
    },
    toYear() {
      return this.form.day_to.year ? moment(this.form.day_to.year).format('yyyy') : new Date().getFullYear()
    },
    toMonth() {
      return this.form.day_to.month ? moment(this.form.day_to.month).format('MM') - 1 : new Date().getMonth()
    },
    tableCostData() {
      let array = []
      let hasTitleArray = []
      this.listHeaders = []
      this.hasActual = {
        approval: [],
        denial: [],
        sendBack: []
      }

      //get title for table row
      if (this.form.day_from.year && this.form.day_from.month && this.form.day_to.year && this.form.day_to.month) {
        const listItemName = this.listItemNameForm2
        if (listItemName) {
          listItemName.forEach(title => {
            array.push({title:title.label_name, item_id:title.item_id})
          })
        }
      }

      for (const [registered_date, value] of Object.entries(this.tableData)) {
        //get headers
        if (!this.listHeaders.includes(registered_date)) {
          this.listHeaders.push(registered_date)
        }

        if (value.is_view_list_approval) {
          if (value.is_approval) {
            if (value.answer_status == 0) {
              this.hasActual.sendBack.push(registered_date)
              this.hasActual.denial.push(registered_date)
              this.hasActual.approval.push(registered_date)
            }

            if (value.answer_status == 1) {
              this.hasActual.sendBack.push(registered_date)
            }
          } else {
            if ([0, 1].includes(value.answer_status)) {
              this.hasActual.sendBack.push(registered_date)
            }
          }
        }

        if (array.length) {
          array.map(array_item => {
            for (const [item_title, item_value] of Object.entries(value.item)) {
              if (array_item.item_id == item_title) {
                array_item[registered_date] = item_value != null ? item_value : '--'
                this.status[`${registered_date}_status`] = value.answer_status
              }
            }
          })
        }
      }

      if (this.answerChildErrors == null) {
        const month_range = moment(this.form.day_to.month).diff(this.form.day_from.month, 'months')
        const start_month = moment(this.form.day_from.month).format('YYYY/MM')
        for (let i = 0; i <= month_range; i++) {
          if (i == 0) {
            if (!this.listHeaders.includes(start_month)) {
              this.listHeaders.push(start_month)
            }
          } else {
            const month = moment(start_month, 'YYYY/MM').add(i, 'M').format('YYYY/MM')
            if (!this.listHeaders.includes(month)) {
              this.listHeaders.push(month)
            }
          }
        }

        this.listHeaders.sort((a, b) => {
          const DateA = moment(a, 'YYYY/MM')
          const DateB = moment(b, 'YYYY/MM')
          if (moment(DateA).isBefore(DateB, 'month')) {
            return -1
          }

          if (moment(DateA).isAfter(DateB, 'month')) {
            return 1
          }

          if (moment(DateA).isSame(DateB, 'month')) {
            return 0
          }
        })
      }

      return array
    }
  },
  methods: {
    ...mapActions(['getListAnswerFormChild', 'setApproval', SET_TITLE_BUSINESS, GET_DETAIL_ANSWER, CHECK_FORM_URL_USER]),
    formatCost(row, col, value, index) {
      if (value == undefined || value == "--") {
        return "--"
      }

      const arr = value.toString().split('.')
      const beforeDot = arr[0]
      const afterDot = arr[1] ? arr[1] : null


      const cost = value ? BigInt(beforeDot) : undefined
      const formatter = new Intl.NumberFormat('ja-JP', { currency: "JPY" }).format(cost)

      if (afterDot) {
        return (cost || cost == 0n) ? `${formatter}.${afterDot}` : `${cost}.${afterDot}`
      } else {
        return (cost || cost == 0n) ? formatter : cost
      }
    },
    formatter(unformated_cost) {
      const arr = unformated_cost.toString().split('.')
      const beforeDot = arr[0]
      const afterDot = arr[1] ? arr[1] : null

      const cost = BigInt(beforeDot)
      const formatter = new Intl.NumberFormat('ja-JP', { currency: "JPY" }).format(cost)

      return afterDot ? `${formatter}.${afterDot}` : formatter
    },
    sortDate() {
      //not yet implement
    },
    disabledDate(date) {
      return moment(date).isBefore(this.getBusiness.jigyo_kikan_from) || moment(date).isAfter(this.getBusiness.jigyo_kikan_to)
    },
    toPerformanceReport() {
      let dateStart = null
      let dateEnd = null

      if (this.form.day_from.year && this.form.day_from.month) {
        dateStart = `${this.form.day_from.year}-${moment(this.form.day_from.month).format('MM')}`
      }
      if (this.form.day_to.year && this.form.day_to.month) {
        dateEnd = `${this.form.day_to.year}-${moment(this.form.day_to.month).format('MM')}`
      }

      this.$router.push({
        name: 'performance-report', query: {
          dateStart,
          dateEnd,
          tax_flag: this.form.tax_flag
        }
      })
    },
    async setApprove(date, status) {
      if (status == 2 || status == 3) {
        this.dialog.status = status
        this.dialog.headerText = status == 2 ? '否認' : '差し戻し'
        this.dialog.dialog = true
        this.dialog.date = date
      }
      if (status == 1) {
        this.setStatus(date, 1)
      }
      // const payload = {
      //   answer_id,
      //   status
      // }

      // await this.setApproval(payload)

      // if (this.answerChildStatus == 200) {
      //   this.notifySuccess(SUCCESS_MESSAGE)
      // } else {
      //   this.notifyError(this.answerChildErrors)
      // }

      // await this.getData()
    },
    async setStatus(date, status) {
      const answer_id = this.tableData[date].answer_id

      await this.setApproval({
        answer_id,
        status,
        reject_reason: this.dialog.reason
      })

      if (this.answerChildStatus == 200) {
        this.notifySuccess(SUCCESS_MESSAGE)
        this.dialog.dialog = false
      } else {
        this.notifyError(this.answerChildErrors)
      }

      await this.getData()
    },
    async getData() {
      if (this.form.day_from.year && this.form.day_from.month && this.form.day_to.year && this.form.day_to.month) {
        this.$refs["ruleForm"].clearValidate()
        const time = {
          date_form: `${this.form.day_from.year}-${moment(this.form.day_from.month).format('MM')}`,
          date_to: `${this.form.day_to.year}-${moment(this.form.day_to.month).format('MM')}`,
          tax_flag: this.form.tax_flag
        }
        const payload = {
          answer_id: this.answer_id,
          time
        }
        this.loading = true
        await this.getListAnswerFormChild(payload)

        if (this.answerChildStatus == 200) {
          this.tableData = this.form2
        }
        if (this.answerChildStatus == 422) {
          this.showErrorMessage(this.answerChildErrors, "ruleForm")
          this.tableData = this.form2
        }

        this.form2_price = this.form2Price
        this.form3_price = this.form3Price
        this.avg_price = this.averagePrice
        this.loading = false
      }
    }
  }
}
</script>

<style>
.el-table th.el-table__cell>.cell{
  padding-left: 0;
  padding-right: 0;
}
.comment-content {
    max-height: 120px;
    overflow: auto;
}
@media screen and (max-width: 1280px) {
  .center-line{
    width: 100%;
  }
}
</style>
